import { ClinicAuthError } from "@auth/clinicAuthClient";
import { getActiveSession } from "@auth/sessionStore";

export interface ListClient<T> {
  list(subject?: string): Promise<T[]>;
}

export async function request<T>(
  call: () => Promise<{ data?: T; response: Response }>,
): Promise<T> {
  if (!getActiveSession())
    throw new ClinicAuthError("invalid_credentials", "No active session");

  let result;
  try {
    result = await call();
  } catch {
    throw new ClinicAuthError("network_error");
  }
  if (!result.data) {
    if (result.response.status === 401)
      throw new ClinicAuthError("invalid_credentials");
    throw new ClinicAuthError(
      "unknown",
      `HTTP ${result.response.status}`,
      result.response.status,
    );
  }
  return result.data;
}

/**
 * Like {@link request}, but for endpoints that return no body (e.g. a 204
 * DELETE). Resolves on a 2xx response and maps non-ok statuses to the same
 * {@link ClinicAuthError} codes so callers share one error vocabulary.
 */
export async function requestVoid(
  call: () => Promise<{ response: Response }>,
): Promise<void> {
  if (!getActiveSession())
    throw new ClinicAuthError("invalid_credentials", "No active session");

  let result;
  try {
    result = await call();
  } catch {
    throw new ClinicAuthError("network_error");
  }
  if (!result.response.ok) {
    if (result.response.status === 401)
      throw new ClinicAuthError("invalid_credentials");
    throw new ClinicAuthError(
      "unknown",
      `HTTP ${result.response.status}`,
      result.response.status,
    );
  }
}
